// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2eqy6","range":"MonthRangeSwitch_range__2sgmV","disabled":"MonthRangeSwitch_disabled__2Vfh_"};